DialogController = App.loadClass 'core::Angular/DialogController'

class exports.EditContactInfoController extends DialogController

    constructor: (@scope, @transitions, @modalInstance, @service, contact) ->
        super(@scope, @transitions, @modalInstance)

        if contact.data.status.type is 'success'
            @scope.user = contact.data.data.user
            @scope.user.require_email = @scope.user.authenticated
            @scope.user.require_phone = @scope.user.phone?
            @scope.states = contact.data.data.states
        else
            @scope.no_user_message = contact.data.status.msg


    save: (pretend) =>
        @scope.user.phone = if @scope.user.phone? then @scope.user.phone.replace(/[\D]+/g, '')

        @setAlert({ type: 'success', msg: 'Saving...' }) if not pretend

        @service.updateContactInfo(@scope.user).then (response) =>
            @closeWithAlert response.data.status if not pretend
